import { Pie } from "react-chartjs-2";
import { useEffect, useState } from "react";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function GraficaCategorias({ mes }) {
    const [datos, setDatos] = useState(null);

    const fetchResumen = (mes) => {
        axios
            .get(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/gastos/categorias?mes=${mes}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            })
            .then((res) => {
                if (res.data.success) {
                    setDatos(res.data.data);
                }
            })
            .catch((err) => console.error(err));
    }

    useEffect(() => {
        fetchResumen(mes);
    }, [mes]);

    if (!datos) return <p>Cargando gráfica...</p>;

    const categorias = datos.map(item => item.categoria);
    const montos = datos.map(item => parseFloat(item.total));


    const colores = [
        "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0",
        "#9966FF", "#FF9F40", "#B5EAD7", "#FFC3A0",
        "#CBAACB", "#FFDAC1"
    ];

    const chartData = {
        labels: categorias,
        datasets: [
            {
                label: "Gastos por categoría",
                data: montos,
                backgroundColor: colores.slice(0, categorias.length),
                borderWidth: 1,
            },
        ],
    };

    return (
        <div style={{ maxWidth: "500px", margin: "2rem auto" }}>
            <h3 style={{ textAlign: "center" }}>Gastos por categoría</h3>
            <Pie data={chartData} />
        </div>
    );
}
